module.exports = "/assets/data/190668f109e3f7add545074350166555-LU3.data.json";